export interface Vec2 {
  readonly x: number;
  readonly y: number;
}

export interface Rect {
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
}

export interface Transform {
  readonly position: Vec2;
  readonly rotation: number;
  readonly facing: "up" | "down" | "left" | "right";
}

export function rectContains(rect: Rect, point: Vec2): boolean {
  return (
    point.x >= rect.x &&
    point.x <= rect.x + rect.width &&
    point.y >= rect.y &&
    point.y <= rect.y + rect.height
  );
}

export function rectAtBottomCenter(position: Vec2, size: { readonly width: number; readonly height: number }): Rect {
  return { x: position.x - size.width / 2, y: position.y - size.height, width: size.width, height: size.height };
}

export function defaultTransform(position: Vec2, rotation = 0): Transform {
  return { position, rotation, facing: "down" };
}

export function clamp(value: number, min: number, max: number): number {
  return min <= max ? Math.min(Math.max(value, min), max) : (min + max) / 2;
}
